<template>
    <div class="templete">
        <div class="tabs">
            <div class="item" :class="{ 'active' : current == 0 } " @click="current = 0">北美材</div>
            <div class="item" :class="{ 'active' : current == 1 } " @click="current = 1">非洲材</div>
            <div class="item" :class="{ 'active' : current == 2 } " @click="current = 2">榉木</div>
            <div class="item" :class="{ 'active' : current == 3 } " @click="current = 3">国标 </div>
        </div>
        <america-original-excel v-show="current == 0"></america-original-excel>
        <africa-original-excel v-show="current == 1"></africa-original-excel>
        <beech-original-excel v-show="current == 2"></beech-original-excel>
        <gb-original-excel v-show="current == 3"></gb-original-excel>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
    }
    .templete{overflow:hidden;height:100%;display: flex;flex-direction: column;}
    .tabs{
        display: flex; align-items: center;
        .item {border-radius: 3px;
            font-size:14px; color: #333333; cursor: pointer; border: 1px solid #333333; padding: 5px 15px;
            &.active{ border: 1px solid #B21111;background-color: #B21111;color:#fff;}
        }
        .item + .item{ margin-left: 30px; }
    }
    .tab_content{ flex: 1; display: flex; flex-direction: column; height: 100%; overflow: hidden; }
</style>
<script>
import americaOriginalExcel from '../../components/setting/americaOriginalExcel.vue'
import africaOriginalExcel from '../../components/setting/africaOriginalExcel.vue'
import beechOriginalExcel from '../../components/setting/beechOriginalExcel.vue'
import gbOriginalExcel from '../../components/setting/gbOriginalExcel.vue'

    export default {
        components:{
            americaOriginalExcel,
            africaOriginalExcel,
            beechOriginalExcel,
            gbOriginalExcel
        },
        data(){
            return{
                current : 0,
            }
        }
    }
</script>
